import { useCallback, useMemo, useState } from 'react';

import { WizardContext, type WizardMode } from './WizardContext';

import type { OrganizationFormValues } from '../model/types';

export const WizardDataProvider = ({
	children,
	defaultValues,
	mode,
}: {
	children: React.ReactNode;
	defaultValues: OrganizationFormValues;
	mode: WizardMode;
}) => {
	const [data, setData] = useState<OrganizationFormValues>(defaultValues);

	const setDataForStep = useCallback(
		(
			step: keyof OrganizationFormValues,
			value: OrganizationFormValues[keyof OrganizationFormValues]
		) => {
			setData((prevData) => ({
				...prevData,
				[step]: value,
			}));
		},
		[]
	);

	const value = useMemo(() => ({ data, setDataForStep, mode }), [data, mode, setDataForStep]);
	return <WizardContext.Provider value={value}>{children}</WizardContext.Provider>;
};
